import React from 'react';
import PropTypes from 'prop-types';

import Desktop from './desktop';
import Mobile from './mobile';

const StatusBar = ({
  isFormTouched,
  isFormValidated,
  isChannelTISales,
  isChannelSMBDigitalFr,
  isFirstStep,
  isLastStep,
  isOrderLastStep,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onBackClick,
  hidePricing,
  hideBackButton,
  isEligible,
  onCreateNewOrder,
  isCreateOrderVisible,
  isFieldReset,
  disableContinue
}) => {
  const getPrice = (amount, allowNegative) =>
    `$${
      amount.toFixed(2) > 0 || (allowNegative && !Number.isNaN(amount))
        ? amount.toFixed(2)
        : '0.00'
    }`;
  return (
    <div className="deskTop">
      <div id="footer-wrapper">
        <div className="container 85%">
          <Desktop
            isOrderLastStep={isOrderLastStep}
            isFormTouched={isFormTouched}
            isFormValidated={isFormValidated}
            isChannelTISales={isChannelTISales}
            isChannelSMBDigitalFr={isChannelSMBDigitalFr}
            isFirstStep={isFirstStep}
            isLastStep={isLastStep}
            dueMonthly={getPrice(dueMonthly)}
            dueNow={getPrice(dueNow, true)}
            onSaveAndExit={onSaveAndExit}
            onDownloadClick={onDownloadClick}
            onProceedClick={onProceedClick}
            onBackClick={onBackClick}
            hidePricing={hidePricing}
            hideBackButton={hideBackButton}
            isEligible={isEligible}
            onCreateNewOrder={onCreateNewOrder}
            isCreateOrderVisible={isCreateOrderVisible}
            disableContinue={disableContinue}
          />
          <Mobile
            isOrderLastStep={isOrderLastStep}
            isFormTouched={isFormTouched}
            isFormValidated={isFormValidated}
            isChannelTISales={isChannelTISales}
            isChannelSMBDigitalFr={isChannelSMBDigitalFr}
            isFirstStep={isFirstStep}
            isLastStep={isLastStep}
            dueMonthly={getPrice(dueMonthly)}
            dueNow={getPrice(dueNow)}
            onSaveAndExit={onSaveAndExit}
            onDownloadClick={onDownloadClick}
            onProceedClick={onProceedClick}
            onBackClick={onBackClick}
            hidePricing={hidePricing}
            hideBackButton={hideBackButton}
            isEligible={isEligible}
            onCreateNewOrder={onCreateNewOrder}
            isCreateOrderVisible={isCreateOrderVisible}
            disableContinue={disableContinue}
          />
        </div>
      </div>
    </div>
  );
};

StatusBar.propTypes = {
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isChannelTISales: PropTypes.bool.isRequired,
  isChannelSMBDigitalFr: PropTypes.bool.isRequired,
  isFirstStep: PropTypes.bool,
  isLastStep: PropTypes.bool,
  isOrderLastStep: PropTypes.bool,
  dueMonthly: PropTypes.number,
  dueNow: PropTypes.number,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onBackClick: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool,
  hideBackButton: PropTypes.bool,
  isEligible: PropTypes.bool.isRequired,
  onCreateNewOrder: PropTypes.func.isRequired,
  isCreateOrderVisible: PropTypes.bool.isRequired,
  isFieldReset: PropTypes.bool.isRequired,
  disableContinue: PropTypes.bool.isRequired
};

StatusBar.defaultProps = {
  dueMonthly: 0,
  dueNow: 0,
  hidePricing: false,
  isFirstStep: false,
  isLastStep: false,
  isOrderLastStep: false,
  hideBackButton: false
};

export default StatusBar;
